import { THEME_VARIANTS } from '../theme-variant';

const overrideButton = (theme) => {
  const isReskin = theme.themeVariant === THEME_VARIANTS.RESKIN;
  theme.overrides.MuiButton = {
    root: {
      // Reskin: pill-shaped, like quote's buttons.
      borderRadius: isReskin ? 22 : 4,
      height: 36,
      padding: isReskin ? '0 22px' : '0 8px',
      minWidth: 0,
      '&$disabled': {
        color: `${theme.colorPalette.white} !important`
      }
    },
    // Reskin: main actions use the accent, matching quote's primary button.
    ...(isReskin && {
      contained: { boxShadow: 'none', '&:hover': { boxShadow: 'none' }, '&:active': { boxShadow: 'none' } },
      outlined: theme.actionStyles.secondary,
      outlinedPrimary: theme.actionStyles.secondary,
      outlinedSecondary: theme.actionStyles.secondary,
      containedPrimary: {
        fontWeight: 600,
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.secondary.contrastText,
        '&:hover': {
          // quote's bark100 hover
          backgroundColor: theme.colorPalette.orange_75,
          '@media (hover: none)': {
            backgroundColor: theme.palette.secondary.main
          }
        },
        '&$disabled': {
          backgroundColor: theme.colorPalette.orange_50_op_70,
          color: `${theme.colorPalette.white} !important`
        }
      }
    }),
    containedSecondary: isReskin
      ? theme.actionStyles.secondary
      : {
          fontWeight: 600,
          '&$disabled': {
            backgroundColor: theme.colorPalette.orange_50_op_70,
            color: `${theme.colorPalette.white} !important`
          }
        },
    text: {
      ...(isReskin && {
        color: theme.colors.action_text,
        borderRadius: 22,
        padding: '0 12px',
        '&:hover': { backgroundColor: theme.colorPalette.beige_50, textDecoration: 'none' }
      })
    },
    textPrimary: {
      ...(isReskin && { color: theme.colors.action_text, '&:hover': { backgroundColor: theme.colorPalette.beige_50 } })
    },
    textSecondary: {
      ...(isReskin && {
        color: theme.colors.action_text,
        '&:hover': { backgroundColor: theme.colorPalette.beige_50, textDecoration: 'none' }
      }),
      '&$disabled': {
        opacity: 0.5,
        color: `${theme.colors.action_text} !important`
      }
    },
    label: {
      textTransform: 'none'
    },
    sizeLarge: {
      padding: '0 22px'
    }
  };

  // this should be fixed by material on newer versions, we can also create a pull requests otherwise
  theme.overrides.MuiIconButton = {
    // Neutral hover for icon actions, including calendar and add/remove buttons.
    ...(isReskin && {
      root: { color: theme.colors.action_icon, '&:hover': { backgroundColor: theme.colorPalette.beige_50 } },
      colorSecondary: {
        color: theme.colors.action_icon,
        '&:hover': { backgroundColor: theme.colorPalette.beige_50 }
      }
    }),
    disabled: {
      color: isReskin ? theme.colors.action_icon : theme.colorPalette.orange_50_op_70,
      opacity: 0.53
    }
  };

  theme.overrides.mui = {
    disabled: {
      color: theme.colorPalette.white
    }
  };
};

export default overrideButton;
